// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const window: Window & { JAnalyticsInterface: any };

const { LoginEvent } = window.JAnalyticsInterface.Event;
const { BrowseEvent } = window.JAnalyticsInterface.Event;

export default class Analytics {
  static LoginEvent(username: string, isSuccessful: boolean) {
    const lEvent = new LoginEvent('web', isSuccessful);
    lEvent.addKeyValue('username', username);
    window.JAnalyticsInterface.onEvent(lEvent);
  }

  static BrowseEvent(id: string, name: string, type: string, duration: number) {
    const bEvent = new BrowseEvent(id, name, type, duration);
    bEvent.addKeyValue('type', type);
    window.JAnalyticsInterface.onEvent(bEvent);
  }
}
